/** "Listing provided by <brokerage>", readable without a click (rule 6(a)(ii)); body-size text. */
export function ListingBrokerage({name}: {name: string}) {
    return <p>Listing provided by {name}</p>;
}
